<template>
  <div
    :class="{'spl-modal-holder-show': isVisible}"
    class="spl-modal-holder"
    @click.self="closeModal">
    <div class="spl-modal">
      <div class="spl-modal__close" @click="closeModal" />

      <form-label>Title</form-label>
      <form-input v-model="internal_news_model.Title" />

      <form-label>Body</form-label>
      <form-textarea v-model="internal_news_model.Body" placeholder="Please use HTML Tags only after 50 characters to not messup the preview..." />

      <div class="row">
        <div class="col6">
          <form-button
            :wide="true"
            :secondary="true"
            @onClick="closeModal">
            Cancel
          </form-button>
        </div>
        <div class="col6">
          <form-button :wide="true" @onClick="submitModal">
            Save
          </form-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import webApi from '../webApi'
import Helpers from '../helpers'
import { mapActions } from 'vuex'

export default {
  name: 'UpdateInternalNews',
  mixins: [Helpers],
  props: {
    updateInternalNews: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      isVisible: false,
      isNew: false
    }
  },
  computed: {

    internal_news_model () {
      return {
        News_ID: this.update_internal_news.News_ID ? this.update_internal_news.News_ID : -1,
        News_Date: this.update_internal_news.News_Date ? this.update_internal_news.News_Date : '',
        New_News: this.update_internal_news.New_News ? this.update_internal_news.New_News : true,
        Title: this.update_internal_news.Title ? this.update_internal_news.Title : '',
        Body: this.update_internal_news.Body ? this.update_internal_news.Body : '',
        Link: this.update_internal_news.Link ? this.update_internal_news.Link : ''
      }
    }

  },
  mounted () {
    window.bus.$on('openUpdateInternalNews', this.handleOpenUpdateInternalNews)
    window.bus.$on('openNewInternalNews', this.handleOpenNewInternalNews)
  },
  beforeDestroy () {
    window.bus.$off('openUpdateInternalNews', this.handleOpenUpdateInternalNews)
    window.bus.$off('openNewInternalNews', this.handleOpenNewInternalNews)
  },
  methods: {
    ...mapActions('news', ['loadNews']),
    handleOpenUpdateInternalNews () {
      this.isVisible = true
      this.isNew = false
    },
    handleOpenNewInternalNews () {
      this.isVisible = true
      this.isNew = true
    },
    // Close the scan window
    closeModal () {
      this.isVisible = false
    },

    //* ******************** Submit the modal ****************
    // Will scan a new event or update an existing one
    submitModal () {
      if (this.isNew) {
        // Create new News
        webApi.split_news.create_internal_News(this.internal_news_model)
          .then((response) => {
            this.loadNews()
            this.closeModal()
          }).catch((response) => {
            window.bus.$emit('openErrorModal', 'Could not create a new one')
          })
      } else {
        // Update old News
        webApi.split_news.update_internal_News(this.internal_news_model)
          .then((response) => {
            this.loadNews()
            this.closeModal()
          }).catch(() => {
            window.bus.$emit('openErrorModal', 'Could not update the news')
          })
      }
    }

  }
}
</script>

<style lang="scss">
</style>
